import axiosInstance from "global/helpers/axiosInstance";
import axiosLogin from "global/helpers/axiosLogin";
import {
  LABORDENDIGITAL_SUCCESS,
  LABORDENDIGITAL_LOADING,
  LABORDENDIGITAL_ERROR,
  LABORDENDIGITAL_RESET,
  LABORDENDIGITAL_ALTATURNO_SET,
  LABORDENDIGITAL_LOAD,
  LABORDENDIGITAL_FLGVOLVER,
} from "../../ActionTypes";

export const wsGetLabOrdenDigital = (nextStep) => (dispatch) => {
  dispatch({
    type: LABORDENDIGITAL_LOADING,
  });

  axiosLogin().then((respuesta) => {
    respuesta
      .get(`/lis/laboratorio/ordendigital/GetByIdPaciente/-1`)
      .then((res) => {
        dispatch({
          type: LABORDENDIGITAL_SUCCESS,
          payload: res.data,
        });
        if (nextStep) nextStep(true, res.data);
      })
      .catch((err) => {
        let error = {
          detail: err.response
            ? err.response.data
            : "Error al contactar el server.",
        };

        dispatch({
          type: LABORDENDIGITAL_ERROR,
          payload: error,
        });
        if (nextStep) nextStep(false, err?.response?.data);
      });
  });
};

export const setLoadingOrdenDigital = (loading) => (dispatch) => {
  dispatch({
    type: LABORDENDIGITAL_LOAD,
    payload: loading,
  });
};

export const setAltaTurnoOrdenDigital = (ordenDigital) => (dispatch) => {
  dispatch({
    type: LABORDENDIGITAL_ALTATURNO_SET,
    payload: ordenDigital,
  });
};

export const setFlgVolverOrdenDigital = (flgVolver) => (dispatch) => {
  dispatch({
    type: LABORDENDIGITAL_FLGVOLVER,
    payload: flgVolver,
  });
};

export const resetLabOrdenDigital = () => (dispatch) => {
  dispatch({
    type: LABORDENDIGITAL_RESET,
  });
};
